// AuthContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { getCookie, setCookie, removeCookie } from "../utils/cookieHelper";
import { UserCookie } from "../utils/constants";
import {
  checkEmptyVal,
  checkObjNullorEmpty,
  GetCookieValues,
} from "../utils/common";
import { clearPendingDeepLinkUrl } from "../utils/deepLinkHelper";

// Create the AuthContext
const AuthContext = createContext();

// Provide the AuthContext to the application
export const AuthProvider = ({ children }) => {
  const [loggedinUser, setloggedInUser] = useState(null);

  // Check for auth token in cookies when the component mounts
  useEffect(() => {
    setloggedInUser(getCookie(UserCookie.CookieName));
  }, []);

  const isAuthenticated = () => {
    let loggedinUser = getCookie(UserCookie.CookieName);
    if (
      checkEmptyVal(loggedinUser) ||
      checkObjNullorEmpty(loggedinUser) ||
      loggedinUser?.accid == 0
    ) {
      return false;
    } else {
      return true;
    }
  };

  // Login function to authenticate the user and set the auth token
  const loginUser = (loginData, isRemember, sessionid) => {
    let defaultProfile = loginData?.Profiles?.find(
      (p) => p.ProfileId == loginData.DefaultProfileId
    ) ||
      loginData?.Profiles?.[0] || {
        ProfileId: 0,
        Name: "",
        PicPath: "",
        ProfileTypeId: 0,
        ProfileType: "",
        CountryId: 0,
        ProfileCategoryIds: "",
      };
    let cookieVal = {
      [UserCookie.AccountId]: loginData.AccountId,
      [UserCookie.SessionId]: sessionid,
      [UserCookie.Email]: loginData.Email,
      [UserCookie.PlanId]: loginData.PlanId,
      [UserCookie.Plan]: loginData.Plan,
      [UserCookie.IsSetupCompleted]: loginData.IsSetupCompleted,
      [UserCookie.Profile]: {
        [UserCookie.ProfileId]: defaultProfile.ProfileId,
        [UserCookie.Name]: defaultProfile.Name,
        [UserCookie.ProfilePic]: loginData.PicPath,
        [UserCookie.ProfileTypeId]: defaultProfile.ProfileTypeId,
        [UserCookie.ProfileType]: defaultProfile.ProfileType,
        [UserCookie.AccountTypeId]: loginData.AccountTypeId,
        [UserCookie.AccountType]: loginData.AccountType,
        [UserCookie.CountryId]: defaultProfile.CountryId,
        [UserCookie.ProfileCategoryIds]: defaultProfile.ProfileCategoryIds,
      },
    };

    setCookie(
      UserCookie.CookieName,
      JSON.stringify(cookieVal),
      isRemember == true && { expires: 30 }
    );
    setloggedInUser(getCookie(UserCookie.CookieName));
  };

  const updateUserProfile = (profileData, directCookieVal = null) => {
    let cookieVal = {};
    if (checkObjNullorEmpty(directCookieVal))
      cookieVal = {
        [UserCookie.AccountId]: loggedinUser?.[UserCookie.AccountId],
        [UserCookie.SessionId]: loggedinUser?.[UserCookie.SessionId],
        [UserCookie.Email]: loggedinUser?.[UserCookie.Email],
        [UserCookie.PlanId]: loggedinUser?.[UserCookie.PlanId],
        [UserCookie.Plan]: loggedinUser?.[UserCookie.Plan],
        [UserCookie.IsSetupCompleted]:
          loggedinUser?.[UserCookie.IsSetupCompleted],
        [UserCookie.Profile]: {
          [UserCookie.ProfileId]: profileData.profileid,
          [UserCookie.Name]: profileData.profilename,
          [UserCookie.ProfilePic]: loggedinUser?.p?.[UserCookie.ProfilePic],
          [UserCookie.ProfileTypeId]: profileData.profiletypeid,
          [UserCookie.ProfileType]: profileData.profiletype,
          [UserCookie.AccountTypeId]:
            loggedinUser?.p?.[UserCookie.AccountTypeId],
          [UserCookie.AccountType]: loggedinUser?.p?.[UserCookie.AccountType],
          [UserCookie.CountryId]: profileData.countryid,
          [UserCookie.ProfileCategoryIds]: profileData.profilecatids,
        },
      };
    else {
      cookieVal = { ...directCookieVal };
    }

    //logoutUser();
    setCookie(UserCookie.CookieName, JSON.stringify(cookieVal), {
      expires: 30,
    });
    setloggedInUser(getCookie(UserCookie.CookieName));
  };

  const updateUserPlan = (planData) => {
    let cookieVal = {
      ...loggedinUser,
      [UserCookie.PlanId]: planData.PlanId,
      [UserCookie.Plan]: planData.Plan,
    };

    //logoutUser();
    setCookie(UserCookie.CookieName, JSON.stringify(cookieVal), {
      expires: 30,
    });
    setloggedInUser(getCookie(UserCookie.CookieName));
  };

  // Logout function to remove the auth token
  const logoutUser = () => {
    clearPendingDeepLinkUrl();
    removeCookie(UserCookie.CookieName, { path: "/" });
    setloggedInUser(null);
  };

  return (
    <AuthContext.Provider
      value={{
        loginUser,
        logoutUser,
        loggedinUser,
        isAuthenticated,
        updateUserProfile,
        updateUserPlan,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to use the AuthContext
export const useAuth = () => useContext(AuthContext);
